<template>
    <transition name="login_background_transition">
        <div class="login_div" v-show="show_publish_dialog">
            <transition name="login_dialog_transition">
                <div class="login_dialog_div" v-show="show_publish_dialog"
                >
                    <div class="nav_bar">
                        <div class="close_dialog_div">
                            <span class="close_dialog_span"
                                  @click="change_pubilsh_dialog('close')"
                            >×</span>
                        </div>

                    </div>
                    <input type="text" placeholder="请输入问题标题" class="publish_title_input" v-model="title">
                    <!--<MarkdownEditor class="publish_markdown_editor"-->
                                    <!--:placeholder="'写点什么吧....'"-->
                                    <!--:preview="preview"-->
                                    <!--@text="get_content">-->
                    <!--</MarkdownEditor>-->
                    <CKEditor @text="get_content"></CKEditor>
                    <div class="publish_tools">
                        <div class="publish_operation_tools">
                            <!--<button class="publish_button publish_preview_button" @click="tab_preview()"-->
                                    <!--v-show="!preview">预览-->
                            <!--</button>-->
                            <!--<button class="publish_button publish_preview_button" @click="tab_preview()"-->
                                    <!--v-show="preview">取消预览-->
                            <!--</button>-->
                            <button class="publish_button" @click="publish">发布</button>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </transition>
</template>

<script type="text/javascript">
    import MarkdownEditor from '@/components/common_components/markdown_editor/markdown.vue'
    import CKEditor from '@/components/common_components/ckeditor/ckeditor.vue'
    import questionApi from '@/api/questions/question.js'
    import {mapState, mapActions} from 'vuex'

    export default {
        data: function () {
            return {
                preview: false,
                content: '',
                title: ''
            }
        },
        components: {
            CKEditor,
            MarkdownEditor
        },

        computed: {
            ...mapState({
                show_publish_dialog: state => state.learning.show_publish_dialog,
            })
        },
        watch: {},
        methods: {
            ...mapActions({
                change_pubilsh_dialog: 'learning/change_pubilsh_dialog',
                add_question: 'learning/add_question',
                change_warning_message: 'warningBar/change_message',
                change_warning_bar_style_class: 'warningBar/change_warning_bar_style_class'
            }),
            tab_preview: function () {
                this.preview = !this.preview
            },
            get_content: function (content) {
                this.content = content
            },
            publish: async function () {
                var lesson_id = this.$route.query.id;
                let res = await questionApi.publish_question({
                    title: this.title,
                    content: this.content,
                    lesson_id: lesson_id,
                    type: 'course',
                    // 这个参数好像是个预留参数暂时没用的样子。
                    'beans': 0
                });
                let data = JSON.parse(res.data.result)
                this.change_warning_message(data.message);
                if (data.code === 'success') {
                    this.change_warning_bar_style_class('success');
                    this.change_pubilsh_dialog('close');
                    this.add_question(JSON.parse(res.data.result).question)
                } else {
                    this.change_warning_bar_style_class('alert');
                }
            }
        }
    }
</script>
<style type="text/css" scoped>
    .login_div {
        height: 100%;
        width: 100%;
        position: fixed;
        background: rgb(0, 0, 0, 0.5);
        z-index: 99;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
    }

    .login_dialog_div {
        opacity: 1;
        width: 850px;
        margin: 80px auto;
        margin-top: 50px;
        background: #fff;
        padding: 10px 20px;
        border-radius: 4px;
        border: 1px solid rgba(0, 0, 0, 0.2);
    }

    /* 登陆背景会淡出 */

    .login_background_transition-leave-active {
        transition: all .4s ease-out;
    }

    .login_background_transition-leave {
        opacity: 1;
    }

    .login_background_transiotion-leave-to {
        opacity: 0;
    }

    /* 登录框会从上至下出来 */

    .login_dialog_transition-enter-active, .login_dialog_transition-leave-active {
        transition: all .3s ease-out;
    }

    .login_dialog_transition-enter, .login_dialog_transition-leave-to {
        transform: translate(0, -35%);
        opacity: 0.3;
    }

    .login_dialog_transition-enter-to, .login_dialog_transition-leave {
        transform: translate(0, 0);
        opacity: 1;
    }

    .close_dialog_div {
        text-align: right;
        color: #000;
        opacity: .2;
        font-size: 21px;
        font-weight: 700;
        text-shadow: 0 1px 0 #fff;
        cursor: pointer;
        height: 20px;
    }

    .nav_bar_ul {
        display: flex;
        justify-content: space-around;
        border: none;
        border-bottom: 1px solid #eee;
        margin-bottom: 10px;
    }

    .nav_bar_li {
        width: 50%;
        text-align: center;
    }

    .nav_bar_li:hover {
        border-bottom: 1px solid #6CF;
    }

    .nav_bar_a {
        display: block;
        font-weight: 700;
        padding: 15px;
        font-size: 18px;
        color: #555;
    }

    .nav_bar_li_active {
        border-bottom: 1px solid #6CF;
    }

    .publish_button {
        padding: 6px 20px;
        background: rgb(8, 191, 145);
        border: 1px solid transparent;
        border-radius: 4px;
        font-size: 16px;
        text-align: center;
        color: #fff;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
        margin-right: 5px;
    }

    .publish_preview_button {
        background-color: #fff;
        color: #66CCFF;
        border-color: #66CCFF;
    }

    .publish_operation_tools {
        display: flex;

    }

    .publish_title_input {
        font-size: 20px;
        padding: .375rem .75rem;
        width: 100%;
        line-height: 1.5;
        /*border: 0;*/
        border-bottom: #ccc 1px solid;
        outline: none;
        box-shadow: none;
        resize: none;
        color: #333;
        background: #f9f9f9;
    }

</style>
